var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeach2 = function SvgBeach2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08 17.915a.75.75 0 1 0 1.34.67l-1.34-.67Zm12.5.67a.75.75 0 1 0 1.34-.67l-1.34.67ZM5.75 18.25l.67.336v.002-.002a1.37 1.37 0 0 1 .06-.104c.046-.08.12-.198.224-.343.208-.29.53-.682.977-1.075.89-.778 2.283-1.564 4.319-1.564V14c-2.464 0-4.196.964-5.306 1.936a7.833 7.833 0 0 0-1.21 1.331 6.321 6.321 0 0 0-.394.627l-.007.013-.002.004-.001.002c0 .001 0 .002.67.337ZM12 15.5c2.036 0 3.43.786 4.319 1.564.448.393.77.785.977 1.075a4.787 4.787 0 0 1 .274.43l.01.017v.002-.002l.67-.336.67-.336v-.003l-.003-.004-.007-.013a2.323 2.323 0 0 0-.099-.176 6.307 6.307 0 0 0-.294-.45 7.836 7.836 0 0 0-1.21-1.332C16.195 14.964 14.463 14 12 14v1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.288 14.737a.75.75 0 0 0 1.423-.474l-1.423.474Zm3.2-7.168a.75.75 0 1 0-.976-1.138l.976 1.138ZM13 14.5l.712-.237v.002l-.001-.005-.009-.027a6.556 6.556 0 0 1-.144-.618 7.79 7.79 0 0 1-.121-1.709c.056-1.358.503-3.01 2.051-4.337l-.976-1.138c-1.952 1.673-2.505 3.771-2.574 5.413a9.288 9.288 0 0 0 .28 2.649 5.36 5.36 0 0 0 .07.243L13 14.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7s-4.25 1.25-6.25 3.25M15 7s3 1 3 4M15 7s-2.05-1.25-6.25-1.25M15 7s2.25-1.25 4.25-1.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBeach2;